import React, { useEffect, useState } from "react";
import {
    Edit as EditIcon,
    Add as AddIcon,
    DynamicFeed,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import { useMemo } from "react";
import { useErrorHandler } from "../../../hooks";
import FormSectionsPage from "./questions/index"
import installmentService from "../../../services/installment.service";
import FormQuestionsPage from "./questions";

const defaultKeys = [
    {
        title: "نام",
        field: "title",
        active: true,
    },
    {
        title: "توضیحات",
        field: "description",
        active: false,
    },
    {
        title: "تعداد اقساط",
        field: "count",
        active: false,
    },
    {
        title: "وضعیت",
        field: "isActive",
    },
];

export default function InstallmentPage() {

    const [data, setData] = useState([]);

    const headerCells = useMemo(
        () => [
            {
                field: "title",
                title: "عنوان",
                mainField: true,
            },
            {
                field: "count",
                title: "تعداد اقساط",
                mainField: false,
            },
            {
                field: "description",
                title: "توضیحات",
                mainField: false,
            },
            {
                field: "isActiveText",
                title: "وضعیت",
                mainField: false,
            },
            {
                field: "createDate",
                title: "تاریخ ایجاد",
                mainField: false,
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await installmentService.getInstallments();
        if (error) {
            return;
        }

        setData(data.map(item => ({ 
            ...item,
            isActiveText: item.isActive ? "فعال" : "غیرفعال",
        })));
    };

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        icon: <DynamicFeed />,
                        modalProps: { fullScreen: true },
                        refreshOnClose: false,
                        modalContent: (props) => <FormQuestionsPage {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد فرم",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="فرم های خرید قسطی"
            />
        </div>
    );
}
